export default "__VITE_ASSET__PakVUSxA__"